import {
    LIST_UNITS,
    LIST_UNITS_SUCCESS,
    LIST_UNITS_ERROR,
    ADD_UNITS,
    SAVE_UNITS,
    SAVE_UNITS_SUCCESS,
    SAVE_UNITS_ERROR,
    DELETE_UNITS,
    DELETE_UNITS_SUCCESS,
    DELETE_UNITS_ERROR,
    EDIT_UNITS,
    UPDATE_UNITS,
    UPDATE_UNITS_SUCCESS,
    UPDATE_UNITS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import unitsData from '../data/units';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'unidad';

//LISTAR UNITS
export function listUnitsAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listUnits() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const units = response.data;
            //const units = unitsData;
            //Llamo al dispatch
            dispatch( listUnitsSuccess(units.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listUnitsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listUnits = () => ({
    type: LIST_UNITS,
    payload: true
});

const listUnitsSuccess = units => ({
    type: LIST_UNITS_SUCCESS,
    payload: units
});

const listUnitsError = error => ({
    type: LIST_UNITS_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addUnitsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addUnits(false) );
        //Abro el formulario
        showForm();
    }
}

const addUnits = isEdit => ({
    type: ADD_UNITS,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveUnitsAction(unit, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveUnits() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, unit);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveUnitsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveUnitsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveUnits = () => ({
    type: SAVE_UNITS,
    payload: true
});


const saveUnitsSuccess = unit => ({
    type: SAVE_UNITS_SUCCESS,
    payload: unit
});

const saveUnitsError = error => ({
    type: SAVE_UNITS_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editUnitsAction(unit, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editUnits(unit) );
        //Abro el formulario
        showForm();
    }
}

const editUnits = unit => ({
    type: EDIT_UNITS,
    payload: unit
});

//UPDATE AUDIENCE CATEGORY
export function updateUnitsAction(unit, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateUnits() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${unit.id}`, unit);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateUnitsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateUnitsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateUnits = () => ({
    type: UPDATE_UNITS,
    payload: true
});

const updateUnitsSuccess = unit => ({
    type: UPDATE_UNITS_SUCCESS,
    payload: unit
});

const updateUnitsError = error => ({
    type: UPDATE_UNITS_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteUnitsAction(unit) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteUnits() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${unit.id}`);
            const response = await clienteAxios.put(`/${controller}/${unit.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteUnitsSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteUnitsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteUnits = () => ({
    type: DELETE_UNITS,
    payload: true
});

const deleteUnitsSuccess = unit => ({
    type: DELETE_UNITS_SUCCESS,
    payload: unit
});

const deleteUnitsError = error => ({
    type: DELETE_UNITS_ERROR,
    payload: error
});